<mat-accordion
  *ngIf="trainingRequirementSkeletons && trainingRequirementSkeletons.length > 0; else noEvents"
>
  <mat-expansion-panel
    *ngFor="let trainingRequirementSkeleton of trainingRequirementSkeletons"
    (opened)="onOpened(trainingRequirementSkeleton.trainingRequirementId)"
  >
    <mat-expansion-panel-header>{{
      trainingRequirementSkeleton.eventTitle
    }}</mat-expansion-panel-header>

    <ng-template matExpansionPanelContent>
      <div *ngIf="loading; else auditsLoaded">Loading...</div>
      <ng-template #auditsLoaded>
        <div *ngIf="audits && audits.length > 0; else noAudits">
          <sd-portal-audit-detail-list
            (nextPage)="onNextPage(trainingRequirementSkeleton.trainingRequirementId)"
            [audits]="audits"
          ></sd-portal-audit-detail-list>
        </div>
        <ng-template #noAudits> No audit records for this training event </ng-template>
      </ng-template>

      <sd-portal-warning-rule-audit-list
        [warningRuleSkeletons]="trainingRequirementSkeleton.warningRules"
        [warningRuleAuditLoading]="warningRuleAuditLoading"
        [warningRuleAudits]="warningRuleAudits"
        (opened)="onOpenedWarningRule($event)"
        (nextPage)="onNextWarningRulePage($event)"
      ></sd-portal-warning-rule-audit-list>
    </ng-template>
  </mat-expansion-panel>
</mat-accordion>
<ng-template #noEvents> No training events to audit </ng-template>
